import { useCallback, useContext } from 'react';
import {
	PerformanceAnalyticsContext,
	type PerformanceAnalyticsValues,
} from '../provider/PerformanceAnalytics';

type ResizeEvent = {
	eventData: PerformanceAnalyticsValues['eventRef']['current']['resized'];
	type: 'resized';
};

type ProductRequestsEvent = {
	eventData: {
		elapsed: number;
		fetchDuration: number;
	};
	type: 'productFetchRequest';
};

export const getPerformanceMark = () => Math.trunc(performance.now());

export const usePerformanceAnalytics = ({ isEnabled }: { isEnabled: boolean }) => {
	const { eventRef, hasSent } = useContext(PerformanceAnalyticsContext);

	const captureEvent = useCallback(
		({ type, eventData }: ResizeEvent | ProductRequestsEvent) => {
			if (!isEnabled) {
				return;
			}

			if (type === 'productFetchRequest') {
				eventRef.current = {
					...eventRef.current,
					productFetch: {
						requests: [
							...(eventRef.current.productFetch?.requests || []),
							{
								elapsed: eventData.elapsed,
								fetchDuration: eventData.fetchDuration,
							},
						],
					},
				};
			} else {
				eventRef.current = {
					...eventRef.current,
					[type]: eventData,
				};
			}
		},
		[isEnabled, eventRef],
	);

	return { event: eventRef.current, hasSent, captureEvent };
};
